export const containers = {
  title: '集装箱',
  resourceName: '集装箱',
  listTitle: '集装箱管理',
  titles: {
    view: '集装箱详情',
    show: '查看集装箱',
    edit: '编辑集装箱',
    create: '创建集装箱',
    list: '集装箱列表',
    addQuick: '快速添加',
  },
  messages: {
    noData: '暂无数据',
    totalContainers: '共 {total} 个集装箱',
    updateSuccess: '集装箱更新成功',
    createSuccess: '集装箱创建成功',
    errorGeneric: '发生错误',
    savedSuccess: '保存成功',
    saving: '保存中...',
    empty: '没有',
    emptyNotes: '没有备注',
    emptyShippingLine: '没有航运公司',
    emptyShippingName: '没有船名',
    emptyProductType: '没有产品类型',
    emptyCustomerName: '没有客户名称',
    emptyCompanyName: '没有公司名称',
    emptyAgency: '没有代理',
    emptySealCn: '没有中国封条',
    emptyDate: '没有日期',
    selectShipments: '选择要装载到集装箱的货物',
    selectShipmentsTooltip: '仅可放置具有完整尺寸信息（长度、宽度、高度、重量）的批次',
    theSelectedShipments: '已选择',
    sortShipments: '排序',
    selectAndRemoveFromContainer: '选择并移除',
  },
  filter: {
    placeholder: '按集装箱代码、参考代码搜索...',
    advancedFilter: '高级筛选',
    code: '集装箱代码',
    refCode: '参考代码',
    status: '状态',
    clearFilter: '清除筛选',
    search: '搜索',
    all: '全部',
  },
  validation: {
    refCodeRequired: '请输入参考代码',
    selectFromToWarehouse: '请选择出发仓库和到达仓库',
    checkDates: '请检查出发、到港和返回日期',
    departureBeforeArrival: '出发日期必须早于或等于到港日期',
    arrivalBeforeReturn: '到港日期必须早于或等于返回日期',
    returnAfterDeparture: '返回日期必须晚于或等于出发日期',
  },
  form: {
    codeAuto: '保存后自动生成',
    refCodePlaceholder: '输入参考代码',
    productTypePlaceholder: '输入产品类型',
    customerNamePlaceholder: '输入客户名称',
    fromWarehousePlaceholder: '出发仓库',
    toWarehousePlaceholder: '到达仓库',
    fromPortPlaceholder: '输入出发港',
    toPortPlaceholder: '输入到达港',
    shippingLinePlaceholder: '输入航运公司',
    shippingNamePlaceholder: '输入船名',
    companyNamePlaceholder: '输入公司名称',
    agencyPlaceholder: '输入代理',
    sealCnPlaceholder: '输入中国封条',
    sealVnPlaceholder: '输入越南封条',
    notesOptional: '输入备注（可选）',
    departureDatePlaceholder: '出发日期',
    arrivalDatePlaceholder: '到港日期',
    returnDatePlaceholder: '返回日期',
  },
  fields: {
    code: '集装箱代码',
    refCode: '参考代码',
    shippingMethod: '运输方式',
    closingDate: '关闭日期',
    departureDate: '出发日期',
    arrivalDate: '到达日期',
    returnDate: '返回日期',
    deliveryDate: '交货日期',
    fromPort: '出发港',
    toPort: '到达港',
    status: '状态',
    notes: '备注',
    fromWarehouseId: '出发仓库',
    toWarehouseId: '到达仓库',
    agency: '代理',
    sealCn: '中国封条',
    sealVn: '越南封条',
    productType: '产品类型',
    customerName: '客户名称',
    shippingLine: '航运公司',
    shippingName: '船名',
    createdAt: '创建于',
    updatedAt: '更新于',
    companyName: '公司名称',
    shipping: '运输详情',
    actions: '操作',
    fromWarehouse: '出发仓库',
    toWarehouse: '到达仓库',
    shippingMethodShort: '方式',
  },
  fieldGroups: {
    basicInfo: '基本信息',
    warehouseInfo: '仓库信息',
    shippingInfo: '运输信息',
    sealInfo: '封条信息',
    additionalInfo: '附加信息',
    scheduleInfo: '计划信息',
  },
  searchCode: {
    label: '通过代码或参考代码搜索',
    placeholder: '输入集装箱代码或参考代码',
  },
  statuses: {
    NEW: '新建',
    LOADING: '装载中',
    CLOSED: '已关闭',
    DEPARTED: '已离港',
    ARRIVED: '已到港',
    RETURNED: '已返回',
    UNLOADING: '卸货中',
    DONE: '完成',
    DELETED: '已删除',
  },
  tabs: {
    overview: '概览',
    listTheShipments: '列表',
    listTheShipmentsTooltip: '只有新建或装载中的集装箱才能列出列表',
    sealInfo: '封条信息',
    shipmentsDraft: '列表 (草稿)',
    shipmentsClosed: '列表 (已关闭)',
  },
  totals: {
    total: 'Total',
    weight: '总重量',
    volume: '总体积',
    shipments: '总批数',
    selectedShipments: '已选择',
  },
  buttons: {
    load: '装载',
    submit: '提交',
    confirm: '确认',
    save: '保存',
  },
}
